import { List as IList } from 'immutable';

import { createSelector } from 'reselect';
import { programStepCompleted } from '../program/programStepSelectors';
import { getFlowProgress } from '../routing/flowSelectors';
import {
    IS_SELFBUY_FIELD, newItemIsSelfBuy, RECIPIENT_NAME_FIELD, SENDER_NAME_FIELD
} from '../item/newItemForm';



export const recipientStepCompleted = createSelector(
    getFlowProgress,
    newItemIsSelfBuy,
    (flowState, isSelfBuy) => (
        isSelfBuy
            ? flowState.has(IS_SELFBUY_FIELD)
            : (
                flowState.has(RECIPIENT_NAME_FIELD)
                && flowState.has(SENDER_NAME_FIELD)
                && flowState.has(IS_SELFBUY_FIELD))
    )
);


export const recipientStepPreConditions = IList([
    programStepCompleted
]);


export const recipientStepPostConditions = IList([
    recipientStepCompleted
]);
